module.exports = __webpack_public_path__ + "media/question3_au.1fbe6f89.mp3";